export const enum TerminalTextStyle {
  Green,
  Sub,
  Subber,
  Text,
  White,
  Red,
  Blue,
  Invisible,
  Underline,
  Mythic,
}
